import { Injectable } from '@angular/core';
import { SwUpdate } from '@angular/service-worker';

@Injectable({
  providedIn: 'root'
})
export class UpdateService {

  constructor(private updates: SwUpdate) {
    if (updates.isEnabled) {
      console.log('UpdateService instantiated');
      this.updates.versionUpdates.subscribe(event => {
        console.log('Version update event:', event);
        switch (event.type) {
          case 'VERSION_DETECTED':
            console.log(`Downloading new app version: ${event.version.hash}`);
            break;
          case 'VERSION_READY':
            console.log(`Current app version: ${event.currentVersion.hash}`);
            console.log(`New app version ready for use: ${event.latestVersion.hash}`);
            this.doUpdate();
            
            break;
          case 'VERSION_INSTALLATION_FAILED':
            console.error(`Failed to install app version '${event.version.hash}': ${event.error}`);
            break;
        }
      });
    }
  }

  private doUpdate() {
    console.log('Updating to new version...');
    this.updates.activateUpdate().then(() => {
      console.log('Update activated, reloading page...');
      document.location.reload();
    }).catch(err => {
      console.error('Error during update activation:', err);
    });
  }

}
